module.exports = __webpack_public_path__ + "d88951a562df46a8d6af5bdd03c258a9.png";